const PAUSE_ROTATION_CLASS = 'js-pause';
const IMGLOADING_CLASS = 'js-loading';
const COUNTDOWN_CLASS = 'js-counting-down';
const COUNTRY_SELECTED = 'es-country-selected';
const PRODUCT_PRICE_SELECTED = 'es-product-price-selected';
const COUNTDOWN_FIN = 'es-countdown-fin-v10';
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expFactor = 1.5;

function pause() { document.body.classList.add(PAUSE_ROTATION_CLASS); }
function play() { document.body.classList.remove(PAUSE_ROTATION_CLASS); }
window.onblur = function() { pause(); }
window.onfocus = function() { play(); }

function startLoad() {
  //console.log('esterminal: start load');
  document.body.classList.add(IMGLOADING_CLASS);
}

function completeLoadAll() {
  //console.log('esterminal: load complete');
  document.body.classList.remove(IMGLOADING_CLASS);
}

function typeWriter($dest, text, n) {
  if (n < text.length) {
    $dest.html(text.substring(0, n + 1));
    n++;
    setTimeout(function() {
      typeWriter($dest, text, n);
    }, 100);
  }
}

/** Currency Helpers - formatMoney - Takes an amount in cents and returns it as a formatted dollar value */
Currency = (function() {
  var moneyFormat = '${{amount}}';
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return { formatMoney: formatMoney };
})();

/** App */
$(function () {
  var $body = $('body');
  var statusElem = document.querySelector('#es-status'), progressElem = document.querySelector('progress');
  var supportsProgress = progressElem && progressElem.toString().indexOf('Unknown') === -1;
  var audio = document.getElementById('es-welcomewhisper');
  var audionoise = document.getElementById('es-staticnoise');
  var stickyInstances = {};

  /** loading **/
  function completeLoadEach(loaded, count, success) {
    //console.log('esterminal: complete load each: ', loaded, count, success);
    indicateLoadProgress(loaded, count, success);
  }

  function indicateLoadProgress(loaded, count, success) {
    if (supportsProgress) {
      if (loaded == 1) { progressElem.setAttribute('max', count); }
      progressElem.setAttribute('value', loaded);
    } else {
      //console.log('esterminal: progress not supported');
    }
  }

  /** Video takeover */
  function setupVideo() {
    var body = document.body;
    var vidpage = document.getElementById('es-videotakeover');
    var video = document.getElementById('entirestudiosvideo');
    var image = document.getElementById('entirestudiosimg');
    var logo = document.getElementById('entirestudioslogo');
    var img = new Image();
    var log = new Image();
    var played = false;
    //console.log('esterminal: video check', video);
    if (video) {
      //console.log('esterminal: video confirmed', video);
      video.addEventListener('loadeddata', function () {
        //console.log('esterminal: video is loaded and can be played');
        body.classList.remove('entirestudiosvideoloading');
        function playPauseMedia(event) {
          if ($(event.target).hasClass('entirestudiosblockvidctrl')) {
            return;
          }
          if (played === false) {
            vidpage.classList.add('entirestudiosplayed');
            played = true;
          }
          if (video.paused) {
            vidpage.classList.add('entirestudiosplaying');
            video.play();
          } else {
            vidpage.classList.remove('entirestudiosplaying');
            video.pause();
          }
        }
        vidpage.addEventListener('click', playPauseMedia);
      }, false);
      video.load();
    }
    if (image) {
      $(img).on('load', function () {
        //console.log('esterminal: image is loaded');
        body.classList.remove('entirestudiosimgloading');
      });
      img.src = image.getAttribute('src');
    }
    if (logo) {
      $(log).on('load', function () {
        //console.log('esterminal: logo is loaded');
        body.classList.remove('entirestudioslogoloading');
      });
      log.src = logo.getAttribute('src');
    }
  }

  function init() {
    startLoad();
    //console.log('esterminal: wait for images');
    $body.waitForImages(completeLoadAll, completeLoadEach);
  }

  /** ON PAGE LOAD **/
  /** SHOP **/
  /**
   * INIT
   * */
  //console.log('esterminal: init on load *entire studios*');
  init();

  /**
   * PAGES
   * */
  pages = [{
    namespace: 'virtualpopup',
  },
  {
    namespace: 'home',
    onLeave: function () {
      //console.log('esterminal: on leave, destroy magnet', fullpage_api);
      fullpage_api.destroy('all');
    },
    onEnterCompleted: function () {
      //console.log('esterminal: welcome page');

      //console.log('esterminal: btn appear - static noise option');
      var btnaudionoise = document.getElementById('es-staticnoise-btn');
      btnaudionoise.addEventListener('click', function (e) {
        //console.log('esterminal: static noise'); audionoise.play();
        btnaudionoise.classList.remove('es-sound-allow-trigger--showing');
      });

      new fullpage('#fullpage', {
        licenseKey: 'gplv3-license',
        sectionSelector: '.vertical-scrolling',
        navigation: false,
        slidesNavigation: true,
        controlArrows: false,
        credits: false,
        scrollingSpeed: 1000,
        loopBottom: true,
        afterLoad: function(anchorLink, index) {},
        onLeave: function(index, nextIndex, direction) {},
        afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex) {},
        onSlideLeave: function(anchorLink, index, slideIndex, direction) {},
        afterRender: function () {
          setInterval(function () {
            fullpage_api.moveSectionDown();
          }, 10000);
        }
      });

      const homeButtons = document.querySelectorAll('.es-button--loop');
      const homeSlides = document.querySelectorAll('.es-homepage-banner-slide--loop');
      const slideVideos = document.querySelectorAll(".es-homepage-video-container video");

      let currentIndex = 0;
      let intervalId;

      function updateActiveClass(index) {
        homeButtons.forEach(button => button.classList.remove('active'));
        homeSlides.forEach(slide => slide.classList.remove('active'));
        homeButtons[index].classList.add('active');
        homeSlides[index].classList.add('active');
        currentIndex = index;
        const video = slideVideos[index];
        if (video) {
          video.currentTime = 0;
          video.play();
        }
      }

      updateActiveClass(currentIndex);

      function startAutoSlide() {
        intervalId = setInterval(() => {
          let nextIndex = (currentIndex + 1) % homeButtons.length;
          updateActiveClass(nextIndex);
        }, 3000);
      }

      startAutoSlide();

      homeButtons.forEach((button, index) => {
        button.addEventListener('mouseenter', () => {
          clearInterval(intervalId);
          updateActiveClass(index);
        });

        button.addEventListener('mouseleave', () => {
          startAutoSlide();
        });
      });

      slideVideos.forEach(video => {
        if (video) {
          video.addEventListener("play", handleFirstPlay, false);
          video.addEventListener("pause", handlePause, false);
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              // Handle the error if playback fails
            });
          }
        }
      });

      let hasPlayedVideos = new Set();

      function handleFirstPlay(event) {
        const vid = event.target;
        if (!hasPlayedVideos.has(vid)) {
          hasPlayedVideos.add(vid);
          vid.removeEventListener("play", handleFirstPlay);
        }
      }

      function handlePause(event) {
        const vid = event.target;
        const playPromise = vid.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            // Handle the error if playback fails
          });
        }
      }
    }
  },
  {
    namespace: 'product-v2',
    onEnterCompleted: function () {
      var $productInfo = $('.es-product-info'),
          $slider = $('.es-product-slider'),
          handle = $productInfo.attr('data-handle');

      //console.log('esterminal: *entire studios*');
      init();

      $slider.on('init', function(event, slick) {
        const $dots = $('.slick-dots');
        $dots.append('<div class="active-indicator"></div>');
        updateActiveIndicatorPosition(slick.currentSlide);
      });

      $slider.slick({
        infinite: true,
        speed: 300,
        autoplay: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        touchMove: true,
        swipe: true,
        dots: true,
        useCSS: false,
        useTransform: false,
        touchThreshold: 200,
        prevArrow: false,
        nextArrow: false,
      });

      function updateSliderSettings() {
        const $currentSlide = $('.slick-slide.slick-current');
        if ($currentSlide.hasClass('es-campaign-slider-image--model')) {
          $slider.slick('slickSetOption', {
            draggable: false,
            touchMove: false,
            swipe: false
          }, false);
        } else {
          $slider.slick('slickSetOption', {
            draggable: true,
            touchMove: true,
            swipe: true
          }, false);
        }
      }

      $slider.on('init', function(event, slick) {
        const $dots = $('.slick-dots');
        $dots.append('<div class="active-indicator"></div>');
        updateActiveIndicatorPosition(slick.currentSlide);
        updateSliderSettings();
      });

      $slider.on('setPosition', function(event, slick) {
        updateActiveIndicatorPosition(slick.currentSlide);
        updateSliderSettings();
      });

      $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        updateActiveIndicatorPosition(nextSlide);
        updateSliderSettings();
      });

      function updateActiveIndicatorPosition(slideIndex) {
        const $activeIndicator = $('.active-indicator');
        const $dots = $('.slick-dots li');
        const $targetDot = $dots.eq(slideIndex);
        const targetLeft = $targetDot.position().left;
        $activeIndicator.css({
          width: $targetDot.find('button').outerWidth(),
          left: targetLeft
        });
      }

      let isDragging = false;
      let startPos = 0;

      function handleCustomDragging(e) {
        if (!isDragging) return;
        let currentPos = e.pageX || e.originalEvent.touches[0].pageX;
        let delta = currentPos - startPos;
        if (delta > 50) {
          $slider.slick('slickPrev');
          isDragging = false;
        } else if (delta < -50) {
          $slider.slick('slickNext');
          isDragging = false;
        }
      }

      function startCustomDragging(e) {
        const $dots = $('.slick-dots');
        if ($dots.is(e.target) || $dots.has(e.target).length > 0) {
          isDragging = true;
          startPos = e.pageX || e.originalEvent.touches[0].pageX;
        }
      }

      function stopCustomDragging() {
        isDragging = false;
      }

      $('.slick-dots').on('mousedown touchstart', startCustomDragging);
      $(document).on('mousemove touchmove', handleCustomDragging);
      $(document).on('mouseup touchend', stopCustomDragging);

      //console.log('esterminal: shopping product', handle);

      function typeWriter(element, text, index) {
        if (!element || !text) return;
        
        if (index === 0) {
          element.empty(); // Очищаем элемент только в начале
        }
        
        if (index < text.length) {
          element.append(text.charAt(index));
          setTimeout(function() {
            typeWriter(element, text, index + 1);
          }, 100);
        }
      }

      var titleSource = $('.es-product-title-dest').data('title');
      var titleDest = $('.es-product-title-dest');
      if (titleDest.length && titleSource) {
        typeWriter(titleDest, titleSource, 0);
      }

      var descriptionEnSource = $('.es-product-description-text').data('description-en');
      var descriptionEnDest = $('.es-product-description-text');
      if (descriptionEnDest.length && descriptionEnSource) {
        typeWriter(descriptionEnDest, descriptionEnSource, 0);
      }

      var sizeLabelSource = $('.custom-size-label').data('size-label');
      var sizeLabelDest = $('.custom-size-label');
      if (sizeLabelDest.length && sizeLabelSource) {
        typeWriter(sizeLabelDest, sizeLabelSource, 0);
      }

      $('body').on('click', '.es-product-title-refresh', function (e) {
        var element = $(this);
        element.hide();
        if (titleDest.length && titleSource) {
          typeWriter(titleDest, titleSource, 0);
        }
        setTimeout(function () {
          element.show();
        }, 5);
      });
      
      // Ensure allPhotosBtn is visible on product page
      const allPhotosBtn = document.getElementById('allPhotosBtn');
      if (allPhotosBtn) {
        allPhotosBtn.style.display = 'block';
        //console.log('Product page: showing allPhotosBtn');
        
        // Add click handler if it doesn't exist
        if (!allPhotosBtn.hasAttribute('data-initialized')) {
          allPhotosBtn.setAttribute('data-initialized', 'true');
          allPhotosBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const modal = document.getElementById('myModal');
            if (modal) {
              modal.style.display = 'flex';
              document.body.style.overflow = 'hidden';
              //console.log('All photos button clicked, modal opened');
            }
          });
        }
      }
    }
  }



  ];

  pages.forEach(function (page) {
    var view = Barba.BaseView.extend(page);
    view.init();
  });

  function newPageInit() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    init();
    setupVideo();
    KlaviyoSubscribe.attachToForms('#email_signup', {
      hide_form_on_success: true,
      success_message: '<div class="es-cn">collection nearing, check your email</div>',
      extra_properties: { $source: '$embed', $method_type: "Klaviyo Form", $method_id: 'embed', $consent_version: 'Embed default text' }
    });
    KlaviyoSubscribe.attachToForms('#email_signup_info', {
      hide_form_on_success: true,
      success_message: '<div class="es-cn">thank you</div>',
      extra_properties: { $source: '$embed', $method_type: "Klaviyo Form", $method_id: 'embed', $consent_version: 'Embed default text' }
    });
    KlaviyoSubscribe.attachToForms('#email_signup_page', {
      hide_form_on_success: true,
      success_message: '<div class="es-cn">thank you</div>',
      extra_properties: { $source: '$embed', $method_type: "Klaviyo Form", $method_id: 'embed', $consent_version: 'Embed default text' }
    });
  }

  // Clear Barba cache to force reload of updated pages
  if (Barba.cache) {
    Barba.cache.clear();
  }
  
  Barba.Pjax.start();
  Barba.Prefetch.init();
  Barba.Dispatcher.on('newPageReady', newPageInit);
  newPageInit();

  $body.on('click', '.js-scroll-to-top', function(e) {
    $('html, body').animate({
      scrollTop: $('body').offset().top
    }, 800);
    e.preventDefault();
  });

  $body.on('click', '.js-history-back', function(event) {
    //console.log('esterminal: simulating browser back');
    var $element = $(this);
    var history = window.history;
    var backlink = $element.data('backlink');
    event.preventDefault();
    if (history.length > 2) {
      //console.log('esterminal: check history', history, history.length);
      history.back();
    } else {
      //console.log('esterminal: use backlink', backlink);
      window.location.href = backlink;
    }
  });

  $body.on('mouseenter', '.es-player--2', function (e) {
    var source = $('.es-player-annotation', this);
    var source1 = source.data('source-1'), source2 = source.data('source-2');
    var dest1 = $('.es-player-annotation-dest-1', source), dest2 = $('.es-player-annotation-dest-2', source);
    $(this).addClass('es-player--2-play');
    typeWriter(dest1, source1, 0);
    typeWriter(dest2, source2, 0);
  });
  $body.on('mouseleave', '.es-player--2', function (e) {
    $(this).removeClass('es-player--2-play');
  });
  $body.on('mouseenter', '.es-player--1', function (e) {
    var source = $('.es-player-annotation', this);
    var source1 = source.data('source-1'), source2 = source.data('source-2');
    var dest1 = $('.es-player-annotation-dest-1', source), dest2 = $('.es-player-annotation-dest-2', source);
    $(this).addClass('es-player--1-play');
    typeWriter(dest1, source1, 0);
    typeWriter(dest2, source2, 0);
  });
  $body.on('mouseleave', '.es-player--1', function (e) {
    $(this).removeClass('es-player--1-play');
  });
  $body.on('mouseenter', '.es-uniform-player-image-container--with-annotation', function (e) {
    $(this).addClass('es-uniform-player-image-container--play');
  });
  $body.on('mouseleave', '.es-uniform-player-image-container--with-annotation', function (e) {
    $(this).removeClass('es-uniform-player-image-container--play');
  });

  $body.on('click', '.js-toggle-sizing-chart', function(e) {
    e.preventDefault();
    $(".es-sizing-chart-container").toggleClass("es-sizing-chart-container--open");
    $(".es-inner-page-container").toggleClass("es-inner-page-container--sizingchart");
    $(".es-sizing-chart-close").toggleClass("es-sizing-chart-close--open");
    $(".es-sizing-chart-toggle").toggleClass("es-sizing-chart-toggle--open");
    $(".es-page").toggleClass("es-page--sizing-open");
  });
  $body.on('click', '.js-toggle-description', function(e) {
    e.preventDefault();
    $(".es-description-toggle").toggleClass("es-description-toggle--open");
  });
  $body.on('click', '.js-toggle-info', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--open");
    $(".es-info-toggle-container").toggleClass("es-info-toggle-container--open");
    var isInfoOpen = $(".es-info-container").hasClass("es-info-container--open");
    $(".js-toggle-info").attr("aria-expanded", isInfoOpen);
    $(".es-info-container").attr("aria-hidden", !isInfoOpen);
  });
  $body.on('click', '.js-toggle-refine', function(e) {
    e.preventDefault();
    $(".es-refine-container").toggleClass("es-refine-container--open");
    $(".es-refine-toggle-container").toggleClass("es-refine-toggle-container--open");
    $(".es-collection-menu-container").removeClass("es-collection-menu-container--open");
    $(".es-refine-container").removeClass("es-refine-container--collection-open");
    $(".es-refine-uniform-container").toggleClass("es-refine-uniform-container--open");
  });
  $body.on('click', '.js-toggle-refine-archive', function(e) {
    e.preventDefault();
    $(".es-refine-container-archive").toggleClass("es-refine-container-archive--open");
    $(".es-refine-toggle-container").toggleClass("es-refine-toggle-container--open");
    $(".es-collection-menu-container").removeClass("es-collection-menu-container--open");
    $(".es-refine-container-archive").removeClass("es-refine-container-archive--collection-open");
  });
  $body.on('click', '.js-toggle-uniform-refine', function(e) {
    e.preventDefault();
    $(".es-refine-colour-container").toggleClass("es-refine-colour-container--open");
    $(".es-refine-uniform-container").toggleClass("es-refine-uniform-container--open");
    $(".es-collection-menu-container").removeClass("es-collection-menu-container--open");
    $(".es-refine-uniform-container").removeClass("es-refine-uniform-container--collection-open");
    $(".es-refine-colour-container").removeClass("es-refine-colour-container--collection-open");
  });
  $body.on('click', '.js-open-toggle-refine', function(e) {
    e.preventDefault();
    $(".es-refine-container").toggleClass("es-refine-container--open");
    $(".es-refine-toggle-container").toggleClass("es-refine-toggle-container--open")
    $(".es-collection-menu-container").removeClass("es-collection-menu-container--open");
    $(".es-refine-container").removeClass("es-refine-container--collection-open");
  });
  $body.on('click', '.js-toggle-collection-menu', function(e) {
    e.preventDefault();
    $(".es-collection-menu-container").toggleClass("es-collection-menu-container--open");
    $(".es-refine-container").toggleClass("es-refine-container--collection-open");
    $(".es-refine-container-archive").toggleClass("es-refine-container-archive--collection-open");
    $(".es-refine-colour-container").toggleClass("es-refine-colour-container--collection-open");
    $(".es-refine-uniform-container").toggleClass("es-refine-uniform-container--collection-open");
  });
  $body.on('click', '.js-info-overlay-toggle', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--info");
    $(".js-info-overlay-toggle").toggleClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--returns");
    $(".js-return-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--privacy");
    $(".js-privacy-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--terms");
    $(".js-terms-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--preorder");
    $(".js-preorder-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--newsletter");
    $(".js-newsletter-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--contact");
    $(".js-contact-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--careers");
    $(".js-careers-overlay-toggle").removeClass("es-info-terms-active");
  });
  $body.on('click', '.js-return-overlay-toggle', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--returns");
    $(".js-return-overlay-toggle").toggleClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--info");
    $(".js-info-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--privacy");
    $(".js-privacy-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--terms");
    $(".js-terms-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--preorder");
    $(".js-preorder-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--newsletter");
    $(".js-newsletter-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--contact");
    $(".es-info-container").removeClass("es-info-container--careers");
  });
  $body.on('click', '.js-privacy-overlay-toggle', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--privacy");
    $(".js-privacy-overlay-toggle").toggleClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--info");
    $(".js-info-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--returns");
    $(".js-return-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--terms");
    $(".js-terms-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--preorder");
    $(".js-preorder-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--newsletter");
    $(".js-newsletter-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--contact");
    $(".es-info-container").removeClass("es-info-container--careers");
  });
  $body.on('click', '.js-terms-overlay-toggle', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--terms");
    $(".js-terms-overlay-toggle").toggleClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--info");
    $(".js-info-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--returns");
    $(".js-return-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--privacy");
    $(".js-privacy-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--preorder");
    $(".js-preorder-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--newsletter");
    $(".js-newsletter-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--contact");
    $(".es-info-container").removeClass("es-info-container--careers");
  });
  $body.on('click', '.js-preorder-overlay-toggle', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--preorder");
    $(".js-preorder-overlay-toggle").toggleClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--info");
    $(".js-info-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--returns");
    $(".js-return-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--privacy");
    $(".js-privacy-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--terms");
    $(".js-terms-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--newsletter");
    $(".js-newsletter-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--contact");
    $(".es-info-container").removeClass("es-info-container--careers");
  });
  $body.on('click', '.js-newsletter-overlay-toggle', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--newsletter");
    $(".js-newsletter-overlay-toggle").toggleClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--shipping");
    $(".js-shipping-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--info");
    $(".js-info-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--returns");
    $(".js-return-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--privacy");
    $(".js-privacy-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--terms");
    $(".js-terms-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--preorder");
    $(".js-preorder-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--contact");
    $(".es-info-container").removeClass("es-info-container--careers");
  });
  $body.on('click', '.js-contact-overlay-toggle', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--contact");
    $(".js-contact-overlay-toggle").toggleClass("es-info-terms-active");
    $(".js-newsletter-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--shipping");
    $(".js-shipping-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--info");
    $(".js-info-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--returns");
    $(".js-return-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--privacy");
    $(".js-privacy-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--terms");
    $(".js-terms-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--preorder");
    $(".js-preorder-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--newsletter");
    $(".js-careers-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--careers");
  });
  $body.on('click', '.js-careers-overlay-toggle', function(e) {
    e.preventDefault();
    $(".es-info-container").toggleClass("es-info-container--careers");
    $(".js-careers-overlay-toggle").toggleClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--contact");
    $(".js-newsletter-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--shipping");
    $(".js-shipping-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--info");
    $(".js-info-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--returns");
    $(".js-return-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--privacy");
    $(".js-privacy-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--terms");
    $(".js-terms-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--preorder");
    $(".js-preorder-overlay-toggle").removeClass("es-info-terms-active");
    $(".es-info-container").removeClass("es-info-container--newsletter");
    $(".js-contact-overlay-toggle").removeClass("es-info-terms-active");
  });

  const POPUP_LABELS_TOGGLE_CLASS = "es-page--virtualpopup-labels";
  const POPUP_MOVES_TOGGLE_CLASS = "es-page--virtualpopup-moves";
  const OFFMODEL_LABELS_TOGGLE_CLASS = "es-label-toggle--with-labels";
  const VIEW_OFFMODEL_TOGGLE_CLASS = "es-view-toggle--off-model";
  const VIEW_OFFMODEL_TOGGLE_PAGE_CLASS = "es-page--off-model";
  const PLAYER_OFFMODEL_TOGGLE_CLASS = "es-character-container--off-model";
  $body.on('click', '.js-toggle-popup-labels', function(e) {
    e.preventDefault();
    $(".es-page--virtualpopup").toggleClass(POPUP_LABELS_TOGGLE_CLASS);
  });
  function popupPause () {
    $(".es-page--virtualpopup").removeClass(POPUP_MOVES_TOGGLE_CLASS);
    $(".es-view-toggle").addClass(VIEW_OFFMODEL_TOGGLE_CLASS);
    $(".es-page--virtualpopup").addClass(POPUP_LABELS_TOGGLE_CLASS);
  }
  function popupPlay () {
    $(".es-page--virtualpopup").addClass(POPUP_MOVES_TOGGLE_CLASS);
    $(".es-view-toggle").removeClass(VIEW_OFFMODEL_TOGGLE_CLASS);
    $(".es-page--virtualpopup").removeClass(POPUP_LABELS_TOGGLE_CLASS);
  }
  $body.on('click', '.js-popup-pause', function(e) {
    e.preventDefault();
    if ($(".es-page--virtualpopup").hasClass(POPUP_MOVES_TOGGLE_CLASS)) {
      popupPause();
    } else {
      popupPlay();
    }
  });
  $body.on('click', '.js-popup-play', function(e) {
    e.preventDefault();
    if (!$(".es-page--virtualpopup").hasClass(POPUP_MOVES_TOGGLE_CLASS)) {
      popupPlay();
    } else {
      popupPause();
    }
  });
  $body.on('click', '.js-toggle-popup-moves', function(e) {
    e.preventDefault();
    $(".es-page--virtualpopup").toggleClass(POPUP_MOVES_TOGGLE_CLASS);
    $(".es-view-toggle").toggleClass(VIEW_OFFMODEL_TOGGLE_CLASS);
  });
  $body.on('click', '.js-toggle-view', function(e) {
    e.preventDefault();
    $(".es-page").toggleClass(VIEW_OFFMODEL_TOGGLE_PAGE_CLASS);
  });
  $body.on('click', '.js-toggle-popup-button-close', function(e) {
    e.preventDefault();
    $(".es-popup-button-container").toggleClass("es-popup-button-container--minimise");
    $(".es-popup-button-close").toggleClass("es-popup-button-close--minimise");
  });
  $body.on('click', '.js-toggle-popup-home-close', function(e) {
    e.preventDefault();
    $(".es-popup-sign-container").toggleClass("es-popup-sign-container--minimise");
  });
  $body.on('click', '.js-toggle-popup-button-fullclose', function(e) {
    e.preventDefault();
    $(".es-popup-button-container").toggleClass("es-popup-button-container--close");
  });

  $body.on('click', '.es-sizing-chart-col', function(e) {
    e.preventDefault();
    $(".es-sizing-chart-col").removeClass("es-sizing-chart-col--show");
    $(this).addClass("es-sizing-chart-col--show");
  });

  $body.on('click', '.es-character-container-inner', function(e) {
    e.preventDefault();
    $(".es-character-container-inner").toggleClass("es-character-container-inner--paused");
  });

  $body.on('click', '.js-search-toggle', function(e) {
    e.preventDefault();
    $(".es-page").toggleClass("es-page--search-active");
    $(".es-search-bar").toggleClass("es-search-bar--show");
    $("#es-search-input").focus();
    $("#es-search-input").val('');
    $(".es-sizing-chart-container").removeClass("es-sizing-chart-container--open");
    $(".es-inner-page-container").removeClass("es-inner-page-container--sizingchart");
    $(".es-page").removeClass("es-page--sizing-open");
    $(".es-sizing-chart-toggle").removeClass("es-sizing-chart-toggle--open");
  });

  $body.on('click', '.es-search-overlay', function(e) {
    e.preventDefault();
    $(".es-page").toggleClass("es-page--search-active");
    $(".es-search-bar").toggleClass("es-search-bar--show");
  });

  newsletterPopupInit();

  function newsletterPopupInit() {
    var previouslyClosed = localStorage.getItem('es-newsletter-notification') === 'closed';

    if (!previouslyClosed) {
      $('.es-newsletter-popup-container').removeClass('es-sp-hidden');
      $('.es-newsletter-popup-container').addClass('es-sp-newsletter-entrance-animation');

      $('body').on('click', function () {
        $('.es-newsletter-popup-container').addClass('es-sp-hidden');
      });
      $('.es-newsletter-popup-container').on('click', function (event) {
        event.stopPropagation();
      });

      $('.es-newsletter-close').on('click', function (event) {
        event.preventDefault();
        $('.es-newsletter-popup-container').addClass('es-sp-hidden');
        localStorage.setItem('es-newsletter-notification', 'closed');
      });
    }
  }
});

/** Add to bag */
// $body.on('click', '.es-add-to-bag', function(e) {
//   var el = $(this);
//   e.preventDefault();

//   if (!el.hasClass('es-add-to-bag--select-variant')) {
//     var variantId = $("input[name=variant]:checked").val();

//     var product = {
//       id: variantId,
//       name: $('.es-product-title').text(),
//       price: parseFloat($('.js-product-price-marker').text().match(/\d+/)[0]),
//       quantity: 1
//     };

//     addToCart(product);

//     window.location.href = 'cart.html';
//   }
// });

// function addToCart(product) {
//   var cart = JSON.parse(localStorage.getItem('cart')) || [];
//   var existingProduct = cart.find(function(item) {
//     return item.id === product.id;
//   });

//   if (existingProduct) {
//     existingProduct.quantity += product.quantity;
//   } else {
//     cart.push(product);
//   }

//   localStorage.setItem('cart', JSON.stringify(cart));
//   //console.log('Product added to cart:', product);
// }
